<mat-tab-group [dynamicHeight]="true" [selectedIndex]="0" [disablePagination]="true">
  <mat-tab>
    <ng-template mat-tab-label><span class="tab-label-text">ACH Limits</span>
    </ng-template>
    <div class="limit-value-container">
      <ng-container *ngIf="displayDailyDebit && achLimit">
        <terra-limit-line-item
          title="Debit (Daily Limit)"
          [usage]="achLimit.totalsDaily?.debits"
          [limit]="achLimit.limits?.dailyDebit">
        </terra-limit-line-item>
      </ng-container>
    
      <ng-container *ngIf="displayDailyCredit && achLimit">
        <terra-limit-line-item
          title="Credit (Daily Limit)"
          [usage]="achLimit.totalsDaily?.credits"
          [limit]="achLimit.limits?.dailyCredit">
        </terra-limit-line-item>
      </ng-container>
    
      <ng-container *ngIf="displayMonthlyDebit && achLimit">
        <terra-limit-line-item
          title="Debit (Monthly Limit)"
          [usage]="achLimit.totalsMonthly?.debits"
          [limit]="achLimit.limits?.monthlyDebit">
        </terra-limit-line-item>
      </ng-container>
    
      <ng-container *ngIf="displayMonthlyCredit && achLimit">
        <terra-limit-line-item
          title="Credit (Monthly Limit)"
          [usage]="achLimit.totalsMonthly?.credits"
          [limit]="achLimit.limits?.monthlyCredit">
        </terra-limit-line-item>
      </ng-container>
    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label><span class="tab-label-text">Wire Limits</span>
    </ng-template>
    <div class="limit-value-container">
      <ng-container *ngIf="!!wireLimit">
        <terra-limit-line-item
          title="Transfer (Daily Limit)"
          [usage]="wireLimit.totalsDaily?.transfers"
          [limit]="wireLimit.limits?.dailyTransfer">
        </terra-limit-line-item>
      </ng-container>
    
      <ng-container *ngIf="!!wireLimit">
        <terra-limit-line-item
          title="Transfer (Monthly Limit)"
          [usage]="wireLimit.totalsMonthly?.transfers"
          [limit]="wireLimit.limits?.monthlyTransfer">
        </terra-limit-line-item>
      </ng-container>
    </div>
  </mat-tab>
</mat-tab-group>